import styled from 'styled-components'

import { BaseStepCountStepStyled } from '../components/BaseStepCountStep/styles/BaseStepCountStepStyled'

interface IStepCountStyledProps {}

export const StepCountStyled = styled.div<IStepCountStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  ${BaseStepCountStepStyled} {
    &.active {
      background-color: ${(props) => props.theme.colors.primary};
    }
  }
`
